import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { ENABLE_TWO_FACTOR_AUTH_FIELD_KEY, ENABLE_TWO_FACTOR_EMAIL_FIELD_KEY, ENABLE_TWO_FACTOR_SMS_FIELD_KEY, IUser } from "@share/common-types";
import { ILoginState } from "@share/store/slices";
import { getPreferenceFromAccount, getPreferenceFromUser, RootState } from "@share/utils";
import { handleUserPreferences, IUserSettingState } from "@store/slices";
import { Spin } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

interface IMapStateToProps {
  userSettingStore: IUserSettingState;
}

interface IProps extends IMapStateToProps {
  user?: IUser;
  fetchUserData: () => void;
}

interface FieldData {
  id: string;
  label: string;
  checked: boolean;
  disabled: boolean;
}

function TwoFactorSettingsComponent(props: IProps) {
  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const dispatch = useDispatch();

  const [requiredAccount, setRequiredAccount] = useState<boolean>(false);
  const [fields, setFields] = useState<FieldData[]>([]);
  const intl = useIntl();
  useEffect(() => {
    setRequiredAccount(JSON.parse(getPreferenceFromAccount(loginStore.account, ENABLE_TWO_FACTOR_AUTH_FIELD_KEY)));
    setFields([
      {
        id: "RequiresTwoFactorEmail",
        label: intl.formatMessage({ id: 'receive.code.email' }),
        disabled: requiredAccount,
        checked: requiredAccount || JSON.parse(getPreferenceFromUser(props.user || null, ENABLE_TWO_FACTOR_EMAIL_FIELD_KEY, "false"))
      },
      {
        id: "RequiresTwoFactorSms",
        label: intl.formatMessage({ id: 'receive.code.sms' }),
        disabled: false,
        checked: JSON.parse(getPreferenceFromUser(props.user || null, ENABLE_TWO_FACTOR_SMS_FIELD_KEY, "false"))
      },
    ]);
  }, [props.user]);

  useEffect(() => {
    if (props.userSettingStore.isSuccess) {
      props.fetchUserData();
    }
  }, [props.userSettingStore]);

  const handleChange = (event: any) => {
    const { id, checked } = event.target;
    dispatch(handleUserPreferences(loginStore.user?.userId, [{ key: id, value: checked.toString() }]));
  };

  return (
    <div className="card shadow-sm border mb-5">
      <div className="card-header border-bottom">
        <h4 className="card-header-title">
          <i className="bi bi-shield-lock mx-2"></i><FormattedMessage id="two.factor.auth" />
        </h4>
      </div>
      <Spin spinning={props.userSettingStore.loading}>
        <form className="card-body">
          <div className="mb-4">
            {
              requiredAccount
                ? <div className="alert alert-info" role="alert"><FormattedMessage id="two.factor.auth.message" /></div>
                : null
            }
          </div>

          {fields?.map((option) =>
            <div
              className="form-check form-switch form-check-md d-flex justify-content-between mb-4"
              key={option.id}
            >
              <label className="form-check-label ps-0 pe-4" htmlFor={option.id}>{option.label}</label>
              <input
                type="checkbox"
                className="form-check-input"
                id={option.id}
                checked={option.checked}
                disabled={option.disabled}
                onChange={handleChange}
              />
            </div>
          )}
        </form>
      </Spin>
    </div>
  );
};

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    userSettingStore: state.userSettingStore
  };
};

const TwoFactorSettings = connect(mapStateToProps)(TwoFactorSettingsComponent);
export default TwoFactorSettings;